import React, { createContext, useState, useEffect } from 'react';

// const PING_RESOURCE = "https://google.com";
// const TIMEOUT_TIME_MS = 3000;
const onlinePollingInterval = 10000;



// const timeout = (time, promise) => {
//     return new Promise(function(resolve, reject) {
//         setTimeout(() => {
//             reject(new Error("Request timed out."));
//         }, time);
//         promise.then(resolve, reject);
//     });
// };
  

const checkOnlineStatus = async () => {
    // const controller = new AbortController();
    // const { signal } = controller

    console.log("Navigator", navigator?.onLine)
    return navigator?.onLine || false;
    // If the browser has no network connection return offline
    // if (!navigator.onLine) return navigator.onLine
    //
    // try {
    //     await timeout(
    //         TIMEOUT_TIME_MS,
    //         fetch(PING_RESOURCE, { mode: 'no-cors', method: "GET",signal})
    //     );
    //     return true;
    // } catch (error) {
    //     // Error Log
    //     console.error(error)
    //     // This can be because of request timed out
    //     // so we abort the request for any case
    //     controller.abort()
    // }
    // return false
}


const OnlineStatusContext = createContext(true);


export const OnlineStatusProvider = (props) => {
    const [isOnline, setOnline] = useState(true);

    const checkStatus = async () => {
        const online = await checkOnlineStatus()
        setOnline(online)
    }

    useEffect(() => {
        window.addEventListener("offline", () => {
            setOnline(false);
        });
    
        // Add polling incase of slow connection
        const id = setInterval(() => {
            checkStatus();
        }, onlinePollingInterval);
    
        return () => {
            window.removeEventListener("offline", () => {
                setOnline(false);
            });    
            clearInterval(id);
        };
    }, []);

    return (
        <OnlineStatusContext.Provider value={isOnline}>
            {props.children}
        </OnlineStatusContext.Provider>
    )

}

export {OnlineStatusContext}